{
  "localSettings": {
    "ancillaries": {
      "productCard": {
        "originalPriceLabel": "Original price"
      }
    }
  },
  "ancillaries": {
    "perBooking": "/ booking",
    "seats": {
      "activePassengerChanged": "Now choosing a seat for {name}"
    },
    "bundle": {
      "conflictingBundle": "",
      "serviceIncludedInBundleNotification": "",
      "upsellCard": {
        "seatWifi": {
          "buttonText": {
            "addCombo": "Add combo",
            "added": "Added"
          },
          "addCombo": {
            "productCardTitle": "Seat + {productName}",
            "title": "10% off when booked together",
            "image": {
              "alt": "",
              "contentId": 3560630,
              "data": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg",
              "teaserTitle": "",
              "responsiveImageLinksData": {
                "landscape_ratio21x9": {
                  "768": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg?impolicy=crop&width=4000&height=1714&x=0&y=791"
                },
                "landscape_ratio16x9": {
                  "768": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg?impolicy=crop&width=4000&height=2250&x=0&y=278"
                },
                "portrait_ratio1x1": {
                  "768": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg?impolicy=crop&width=2666&height=2666&x=681&y=0"
                },
                "landscape_ratio4x3": {
                  "768": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg?impolicy=crop&width=3555&height=2666&x=445&y=0"
                }
              }
            }
          },
          "addProduct": {
            "title": "Get internet for less withn a seat",
            "image": {
              "alt": "",
              "contentId": 3560630,
              "data": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg",
              "teaserTitle": "",
              "responsiveImageLinksData": {
                "landscape_ratio21x9": {
                  "768": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg?impolicy=crop&width=4000&height=1714&x=0&y=791"
                },
                "landscape_ratio16x9": {
                  "768": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg?impolicy=crop&width=4000&height=2250&x=0&y=278"
                },
                "portrait_ratio1x1": {
                  "768": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg?impolicy=crop&width=2666&height=2666&x=681&y=0"
                },
                "landscape_ratio4x3": {
                  "768": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg?impolicy=crop&width=3555&height=2666&x=445&y=0"
                }
              }
            }
          }
        }
      },
      "toggle": {
        "personalized": {
          "comboOfferText": "Personalized combo"
        }
      },
      "bundlePriceLabel": "Bundle price",
      "discountLabel": "{percentage}% discount",
      "serviceCard": {
        "inCartTag": "In cart",
        "tierBenefitTag": "Benefit"
      },
      "quota": {
        "enoughForAll": {
          "title": {
            "singular": "Only {amount} combo left",
            "plural": "Only {amount} combos left"
          },
          "description": "Add yours before they run out."
        },
        "allSelected": {
          "title": "No combos left",
          "description": "You have added a combo for everyone in the booking."
        },
        "shortForGroup": {
          "title": {
            "singular": "Only {amount} combo left for your group of {passengerCount}",
            "plural": "Only {amount} combos left for your group of {passengerCount}"
          },
          "description": "Availability is limited on this flight.",
          "noneLeft": "No combos left for this flight."
        },
        "takenByOtherPassenger": "You've added the last available combo to another passenger."
      }
    },
    "ancillaryCombos": {
      "eligibility": {
        "boundFlown": "This flight has already departed.",
        "notAvailableBus": "Unfortunately, combo offers <b>cannot be added for this part of your journey</b> because this is a bus connection.",
        "notAvailableTrain": "Unfortunately, combo offers <b>cannot be added for this part of your journey</b> because this is a train connection."
      },
      "noAncillaryCombosAvailable": "No combo offers available for this part of your journey.",
      "noAncillaryCombosAvailableBus": "Unfortunately, combo offers <b>cannot be added for this part of your journey</b> because this is a bus connection.",
      "noAncillaryCombosAvailableForOperatingAirline": "Combo offers are not available on this flight"
    },
    "seatMeal": {
      "quota": {
        "enoughForAll": {
          "title": {
            "singular": "Only {amount} Seat + Meal combo left",
            "plural": "Only {amount} Seat + Meal combos left"
          },
          "description": "Add yours before the pre-order meals run out."
        },
        "allSelected": {
          "title": "No Seat + Meal combos left",
          "description": "You have added a Seat + Meal combo for everyone in the booking."
        },
        "shortForGroup": {
          "title": {
            "singular": "Only {amount} Seat + Meal combo left for your group of {passengerCount}",
            "plural": "Only {amount} Seat + Meal combos left for your group of {passengerCount}"
          },
          "description": "Pre-order meals are limited on this flight.",
          "noneLeft": "The pre-order meals in the Seat + Meal combo have run out for this flight."
        },
        "takenByOtherPassenger": "You've added the last available Seat + Meal combo to another passenger.",
        "quotaReached": "Pre-order meals attached to this combo have run out for this flight."
      }
    },
    "wifiMeal": {
      "quota": {
        "enoughForAll": {
          "title": {
            "singular": "Only {amount} Internet + Meal combo left",
            "plural": "Only {amount} Internet + Meal combos left"
          },
          "description": "Add yours before the pre-order meals run out."
        },
        "allSelected": {
          "title": "No Internet + Meal combos left",
          "description": "You have added an Internet + Meal combo for everyone in the booking."
        },
        "shortForGroup": {
          "title": {
            "singular": "Only {amount} Internet + Meal combo left for your group of {passengerCount}",
            "plural": "Only {amount} Internet + Meal combos left for your group of {passengerCount}"
          },
          "description": "Pre-order meals are limited on this flight.",
          "noneLeft": "The pre-order meals in the Internet + Meal combo have run out for this flight."
        },
        "takenByOtherPassenger": "You've added the last available Internet + Meal combo to another passenger.",
        "quotaReached": "Pre-order meals attached to this combo have run out for this flight."
      }
    },
    "seatPriority": {
      "quota": {
        "enoughForAll": {
          "title": {
            "singular": "Only {amount} Seat + Priority combo left",
            "plural": "Only {amount} Seat + Priority combos left"
          },
          "description": "Add yours before the priority services run out."
        },
        "allSelected": {
          "title": "No Seat + Priority combos left",
          "description": "You have added a Seat + Priority combo for everyone in the booking."
        },
        "shortForGroup": {
          "title": {
            "singular": "Only {amount} Seat + Priority combo left for your group of {passengerCount}",
            "plural": "Only {amount} Seat + Priority combos left for your group of {passengerCount}"
          },
          "description": "Priority services are limited on this flight.",
          "noneLeft": "The priority services in the Seat + Priority combo have run out for this flight."
        },
        "takenByOtherPassenger": "You've added the last available Seat + Priority combo to another passenger.",
        "quotaReached": "Priority services attached to this combo have run out for this flight."
      }
    },
    "loungePriority": {
      "quota": {
        "enoughForAll": {
          "title": {
            "singular": "Only {amount} Lounge + Priority combo left",
            "plural": "Only {amount} Lounge + Priority combos left"
          },
          "description": "Add yours before the priority services run out."
        },
        "allSelected": {
          "title": "No Lounge + Priority combos left",
          "description": "You have added a Lounge + Priority combo for everyone in the booking."
        },
        "shortForGroup": {
          "title": {
            "singular": "Only {amount} Lounge + Priority combo left for your group of {passengerCount}",
            "plural": "Only {amount} Lounge + Priority combos left for your group of {passengerCount}"
          },
          "description": "Priority services are limited on this flight.",
          "noneLeft": "The priority services in the Lounge + Priority combo have run out for this flight."
        },
        "takenByOtherPassenger": "You've added the last available Lounge + Priority combo to another passenger.",
        "quotaReached": "Priority services attached to this combo have run out for this flight."
      }
    }
  },
  "shoppingCart": {
    "addedTravelExtras": "Added travel extras",
    "allFlights": "All flights",
    "included": "Included",
    "partnerFlightNotification": {
      "singular": "{routes} is operated by our partner. Check available extras and exact allowance on their website.",
      "plural": "{routes} are operated by our partners. Check available extras and exact allowances on their websites."
    }
  },
  "paxDetails": {
    "reviewTitle": {
      "single": "Review passenger details",
      "multi": "Review and add details"
    }
  },
  "purchase": {
    "success": {
      "stayInTouch": {
        "default": {
          "title": "We’ll send updates to help you prepare",
          "description": "<p>You'll receive reminders, tips and offers for your upcoming trip by email.</p><p>You can change your communication preferences anytime in your <a href='https://www.finnair.com/fi-en/my-finnair-plus/update-profile?section=marketing-preferences' target='_blank' rel='noopener noreferrer'>Finnair Plus profile</a>.</p>"
        },
        "multiPassenger": {
          "title": "We’ll send updates to help you prepare",
          "description": "<p>You'll receive reminders, tips and offers for your upcoming trip by email. Others in this booking may also receive them, based on their communication preferences.</p><p>You can change your preferences anytime in your <a href='https://www.finnair.com/fi-en/my-finnair-plus/update-profile?section=marketing-preferences' target='_blank' rel='noopener noreferrer'>Finnair Plus profile</a>.</p>"
        },
        "emailMismatch": {
          "title": "We’ll send updates to help you prepare",
          "description": "<p>You'll receive reminders and tips for your upcoming trip to the email address used when booking: {email}.</p><p>You can manage your communication preferences using the link in the email footer.</p>"
        },
        "multiPassengerEmailMismatch": {
          "title": "We’ll send updates to help you prepare",
          "description": "<p>You'll receive reminders and tips for your upcoming trip to the email address used when booking: {email}. Others in this booking may also receive them, based on their communication preferences.</p><p>You can manage your preferences using the link in the email footer.</p>"
        }
      }
    }
  }
}
